const state = {
  common: {
    regions: [],
    projects: [],
    shiftTypes: [],
    date: null,
    bannedDates: [],
  },
  loading: false,
};

export default state;
